import React from 'react';
import Filter from '../components/Filter';
import * as styles from '../styles/filterList.module.scss';

interface Props<T extends string> {
  filters: {
    name: string;
    value: T;
  }[];
  selectedFilter: T;
  onSelected: (filter: T) => void;
}

const FilterList = <T extends string>({
  selectedFilter,
  onSelected,
  filters,
}: Props<T>) => {
  return (
    <div className={styles.filter_container}>
      {filters.map((filter, i) => (
        <Filter
          key={i}
          selected={selectedFilter === filter.value}
          onClick={() => {
            // dispatch(visibilityFilterSet({ filter: filter.value }));
            onSelected(filter.value);
          }}
        >
          {filter.name}
        </Filter>
      ))}
    </div>
  );
};

export default FilterList;
